<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <sui-panel :title="$t('MSG_TIT_RLTD_TASK_SITE')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RLTD_TASK')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectTask"
                :selected="companyData.selectedCodeValue.companyRelatedTaskDivCode"
                :pageId="this.$options.name"
                :defaultOption="'select'"
                codeId="COD_COMP_RLTD_TASK_DIV"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <cmp-site-select
                ref="selectSite"
                :pageId="this.$options.name"
                :selected="companyData.selectedCodeValue.siteId"
                :defaultOption="'select'"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_COMP_BSIC_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GEHS_COMP_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyId"
                :readonly="true"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_NAT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectNation"
                :selected="companyData.selectedCodeValue.nationCode"
                :pageId="this.$options.name"
                :defaultOption="'select'"
                codeId="COD_ITGR_NAT"
                :disabled="connectionCompanyFlag"
                @list-clicked="onNationSelect"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CONN_COMP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <bqms-vendor-select
                :selected="bqmsCompany"
                :readonly="true"
                @selected="onBqmsVendorSelectClick"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CORP_DSTG_NO')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.corpRegNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
              <div class="comp_spacing" />
              <sui-button
                v-if="!connectionCompanyFlag"
                v-permission:read="this.$options.name"
                type="button"
                class="comm_btn_duplicate"
                @click="onDuplicateCheckClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ERP_COMP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.gerpCompanyNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_REG_STATUS')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyRegistrationStateName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ACC_GRP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyAccountGroupCode"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ACC_GRP')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyAccountGroupName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TRD_PSBL_YN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-yn-select
                ref="selectTradePossibility"
                :selected="companyData.selectedCodeValue.companyTradePossibilityYn"
                :defaultOption="'select'"
                :disabled="connectionCompanyFlag"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_BIZ_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_LCL_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                v-model="companyData.companyName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_BIZ_DIV')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectBizDivision"
                :selected="companyData.selectedCodeValue.bizDivisionCode"
                :pageId="this.$options.name"
                :defaultOption="'select'"
                codeId="COD_BIZ_DIV"
                :disabled="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_GLBL_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                v-model="companyData.companyGlobalName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyRepresentativeName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ESTB_DT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-date-picker
                ref="dp"
                v-model="companyData.companyEstablishDTM"
                :disabled="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_SCALE')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectScale"
                :selected="companyData.selectedCodeValue.companyScaleCode"
                :pageId="this.$options.name"
                :defaultOption="'select'"
                codeId="COD_COMP_SCALE"
                :disabled="connectionCompanyFlag"
                @list-clicked="onScaleSelect"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_AFCP_YN')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-yn-select
                ref="selectAffiliatedDivision"
                :selected="companyData.selectedCodeValue.affiliatedCompanyDivisionCode"
                :defaultOption="'select'"
                :disabled="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TCNT_EMPO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyEmpValue"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CBNO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.corpBizNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_ADDR_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_EMAIL')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                v-model="companyData.companyRepresentativeEmail"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_TEL')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyRepresentativeTelNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_HMPG')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                v-model="companyData.companyHomepageUrl"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_FAX_NO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyFaxNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ADDR')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                v-model="companyData.companyAddress"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ZIP')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="companyData.companyZipCode"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel
        v-if="connectionCompanyFlag"
        :title="$t('MSG_TIT_COMP_CATG_INFO')"
        sticky
      >
        <div class="mrB10" />
        <sui-grid
          :columns="gridColumns0"
          :dataset="'dataset0'"
          :rowMovable="false"
          :multiselect="false"
          :pageable="false"
          :hideHeader="true"
          :sortable="false"
          :filterable="false"
        />
      </sui-panel>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_border"
            @click="onListClick"
          >
            {{ $t('MSG_BTN_LIST') }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-permission:delete="this.$options.name"
            type="button"
            class="comm_btn_border"
            @click="onDeleteClick"
          >
            {{ $t('MSG_BTN_DEL') }}
          </sui-button>
          <sui-button
            v-permission:create="this.$options.name"
            type="button"
            class="comm_btn_border_Prime"
            @click="onSaveClick"
          >
            {{ $t('MSG_BTN_SAVE') }}
          </sui-button>
          <sui-button
            v-permission:create="this.$options.name"
            type="button"
            class="comm_btn_solid"
            @click="onSubmitClick"
          >
            {{ $t('MSG_BTN_SUBM') }}
          </sui-button>
        </div>
      </div>
      <sui-popup
        v-model="isShownPopupSelect"
        :title="$t('MSG_TIT_CONN_COMP_INFO_SELT')"
      >
        <p01
          :pageId="this.$options.name"
          @searchAndCanelView="searchAndCanelView"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import p01 from './components/PGE_CMY_00011_P01';
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00011', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      companyData: {
        selectedCodeValue: {
          companyRelatedTaskDivCode: {
            key: '',
            label: '',
          },
          siteId: {
            key: '',
            label: '',
          },
          nationCode: {
            key: '',
            label: '',
          },
          companyTradePossibilityYn: {
            key: '',
            label: '',
          },
          bizDivisionCode: {
            key: '',
            label: '',
          },
          companyScaleCode: {
            key: '',
            label: '',
          },
          affiliatedCompanyDivisionCode: {
            key: '',
            label: '',
          },
        },
        companyId: '',
        companyName: '',
        companyGlobalName: '',
        corpRegNumber: '',
        corpBizNumber: '',
        companyRepresentativeName: '',
        companyRepresentativeTelNumber: '',
        companyEstablishDTM: '',
        companyFaxNumber: '',
        companyZipCode: '',
        companyAddress: '',
        companyRepresentativeEmail: '',
        bizTypeName: '',
        bizConditionsName: '',
        nationName: '',
        companyHomepageYn: '',
        companyHomepageUrl: '',
        companyEmpValue: '',
        companyScaleValue: '',
        gerpCompanyNumber: '',
        connectionCompanyNumber: '',
        companyAccountGroupCode: '',
        companyAccountGroupName: '',
        companyCloseAccountsDTM: '',
        companyCapitalAmount: '',
        companyCapitalSumAmount: '',
        companyDebtSumAmount: '',
        companyDebtRatioValue: '',
        companyCapitalSurplusAmount: '',
        companyRegistrationStateName: '',
        companyUseYn: '',
      },
      bqmsCompany: {
        connectionCompanyNumber: '',
      },
      vendorCreditEvaluationList: [],
      vendorCategoryList: [],
      validFields: [
        'siteId', 'companyRelatedTaskDivCode', 'nationCode', 'companyName', 'corpRegNumber',
        'companyGlobalName', 'bizDivisionCode', 'companyRepresentativeName',
        'companyEstablishDTM', 'companyScaleCode', 'affiliatedCompanyDivisionCode',
        'companyRepresentativeEmail', 'companyAddress', 'companyRepresentativeTelNumber',
      ],
      localdata0: [],
      gridColumns0: [{
        text: 'No.',
        datafield: 'dataset-row-id',
      }, {
        text: this.$t('MSG_TXT_COMP_CATG_LVL1'),
        datafield: 'level1',
      }, {
        text: this.$t('MSG_TXT_COMP_CATG_LVL2'),
        datafield: 'level2',
      }, {
        text: this.$t('MSG_TXT_COMP_CATG_LVL3'),
        datafield: 'level3',
      }, {
        text: this.$t('MSG_TXT_COMP_CATG_LVL4'),
        datafield: 'level4',
      }, {
        text: this.$t('MSG_TXT_NOTE'),
        datafield: 'note',
      }],
      isShownPopupSelect: false,
      duplicateFlag: false,
      validMessage: '',
    };
  },
  computed: {
    // 상생업체 선택 여부 - 하단 카테고리 패널 띄우기
    connectionCompanyFlag() {
      return !utils.isEmpty(this.companyData.connectionCompanyNumber);
    },
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'dataset-row-id', map: 'dataset-row-id' },
      { type: 'string', name: 'level1', map: 'level1' },
      { type: 'string', name: 'level2', map: 'level2' },
      { type: 'string', name: 'level3', map: 'level3' },
      { type: 'string', name: 'level4', map: 'level4' },
      { type: 'string', name: 'note', map: 'note' },
    ],
  }],
  methods: {
    // ---------------------------------------registration Method-----------------------------------
    onSearchAndCancelClick() {
      this.searchAndCanelView();
    },
    searchAndCanelView(eprCode) {
      this.isShownPopupSelect = !this.isShownPopupSelect;
      if (!utils.isEmpty(eprCode)) {
        this.connectionCompanyDataLoad(eprCode);
      }
    },
    connectionCompanyDataLoad(eprCode) {
      http.request(this.$options.name, 'DTS_CMY_00045', {
        path: {
          'epr-code': eprCode,
        },
      }).then(res => {
        // 업체 등록여부 체크
        this.duplicateCheckAction(this.getCheckData(res.data.taxNo2, res.data.erpeprCode), res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    resetCompanyData() {
      utils.forEach(this.companyData, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(this.$refs, (ref, refkey) => {
            if (utils.startsWith(refkey, 'select')) {
              ref.reset();
            }
          });
        } else {
          this.companyData[key] = '';
        }
      });
      this.vendorCreditEvaluationList = [];
      this.vendorCategoryList = [];
      this.dataset0.reset();
    },
    setCompanyDataByConnectionCompanyData(data) {
      // 업체 카테고리 리스트 생성
      this.dataset0.setRawData(this.categoryFormatToList(data.vendorCategoryList, 4));
      // 기본정보 업데이트
      const address = `${data.localeCityName} ${data.localeCountryName} ${data.localeBunjiNo} ${data.localeAddInfo}`;
      this.vendorCreditEvaluationList = data.vendorCreditEvaluationList;
      this.vendorCategoryList = data.vendorCategoryList;
      this.companyData.connectionCompanyNumber = data.eprCode;
      this.companyData.corpRegNumber = data.taxNo2;
      this.companyData.gerpCompanyNumber = data.erpeprCode;
      this.companyData.companyAccountGroupCode = data.accountGroupCode;
      this.companyData.companyAccountGroupName = data.accountGroup;
      this.companyData.companyName = data.eprName;
      this.companyData.companyGlobalName = data.englishEprName;
      this.companyData.companyRepresentativeName = data.presidentName;
      this.companyData.companyEstablishDTM = utils.toStringByFormat(data.eprEstablishDate, 'YYYY-MM-DD'); // dateformat
      this.companyData.companyEmpValue = data.totalEmployeeNumber;
      this.companyData.corpBizNumber = data.taxNo3;
      this.companyData.companyRepresentativeEmail = data.presidentEmail;
      this.companyData.companyRepresentativeTelNumber = data.presidentTel;
      this.companyData.companyFaxNumber = data.faxNo;
      this.companyData.companyAddress = address;
      this.companyData.companyZipCode = data.zipNo;
      this.companyData.companyHomepageYn = data.homepageYn;
      this.companyData.companyHomepageUrl = data.homepageUrl;
      this.companyData.nationName = data.nation;
      this.companyData.companyScaleValue = data.entpScale;
      // 선택
      this.$refs.selectNation.select(data.nationCode);
      this.$refs.selectTradePossibility.select(utils.isEmpty(data.blockFlag) ? 'Y' : 'N');
      this.$refs.selectBizDivision.select(data.bizCodeName);
      this.$refs.selectScale.select(data.entpScaleCode);
      this.$refs.selectAffiliatedDivision.select(data.relationCompanyCode);
    },
    onBqmsVendorSelectClick(selected) {
      if (!utils.isEmpty(selected.connectionCompanyNumber)) {
        this.connectionCompanyDataLoad(selected.connectionCompanyNumber);
      }
    },
    categoryFormatToList(list, level, parentId) {
      const datasetList = [];
      if (level === 0) return null;
      if (level === 4) {
        let fromindex = -1;
        do {
          fromindex = utils.findIndex(list, data => data.companyCategoryLevel === 4, fromindex + 1);
          if (fromindex > -1) {
            const add = this.getLevelObject(level, list[fromindex].companyCategoryName);
            const result = this.categoryFormatToList(list, level - 1, list[fromindex].parentsCompanyCategoryId);
            datasetList.push(utils.assign(add, result));
          }
        } while (fromindex > -1);
        return datasetList;
      }
      const find = utils.findIndex(list, data => utils.isEqual(data.companyCategoryId, parentId));
      const add = this.getLevelObject(level, list[find].companyCategoryName);
      return utils.assign(add, this.categoryFormatToList(list, level - 1, list[find].parentsCompanyCategoryId));
    },
    getLevelObject(level, value) {
      const objectkey = ['level1', 'level2', 'level3', 'level4'];
      const data = {};
      data[objectkey[level - 1]] = value;
      return data;
    },
    getCheckData(corpRegNumber, gerpCompanyNumber) {
      const gerpText = utils.isEmpty(gerpCompanyNumber) ? this.$t('MSG_TXT_NONE') : gerpCompanyNumber;
      return {
        corpRegNumber,
        gerpCompanyNumber,
        crnoFlag: utils.isEmpty(corpRegNumber),
        crnoMsg: `- ${this.$t('MSG_TXT_CORP_DSTG_NO')}: ${corpRegNumber}\n`,
        erpMsg: `- ${this.$t('MSG_TXT_ERP_COMP_CD')}: ${gerpText}`,
      };
    },
    onDuplicateCheckClick() {
      const checkData = this.getCheckData(this.companyData.corpRegNumber, this.companyData.gerpCompanyNumber);
      if (checkData.crnoFlag) {
        // 사업자식별번호 입력하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CORP_DSTG_NO')));
      } else if (!utils.isEqual(this.companyData.selectedCodeValue.nationCode.key, 'KR')
                  || utils.isKoreaCorpRegNumber(checkData.corpRegNumber)) {
        // 중복체크하겠슴?
        utils.messageBox('confirm', this.$t('MSG_ALT_IS_DPCT_CHK'), checkData.crnoMsg + checkData.erpMsg, () => {
          this.duplicateCheckAction(checkData);
        });
      } else {
        utils.messageBox('warning', '사업자식별번호 양식을 맞춰주세요');
      }
    },
    duplicateCheckAction(checkData, connData) {
      http.request(this.$options.name, 'DTS_CMY_00047', {
        query: checkData,
      }).then(res => {
        // const { companyId } = res.data;
        if (!utils.isEmpty(res.data)) {
          // 중복입니다. 해당 업체 조회하겠슴?
          this.duplicateFlag = false;
          const sub = checkData.crnoMsg + checkData.erpMsg;
          utils.messageBox('confirm', this.$t('MSG_ALT_DPCT_COMP_IS_SRCH'), sub, () => {
            this.goDetailView(res.data);
          }, null);
        } else if (utils.isEmpty(connData)) {
          // 타이핑해서 등록 시 -> 사용가능합니다.
          const availableMsg = utils.strFormat(this.$t('MSG_ALT_USE_PSBL'), this.$t('MSG_TXT_COMP_INFO'));
          utils.messageBox('success', availableMsg, null, () => {
            this.duplicateFlag = true;
          });
        } else {
          // 상생업체 선택 시 -> 사용가능합니다.(자동 로딩)
          this.setCompanyDataByConnectionCompanyData(connData);
        }
      }).catch(error => {
        console.log(error);
        this.duplicateFlag = false;
      });
    },
    goDetailView(companyData) {
      const { companyId, connectionCompanyNumber, companyRegistrationStateCode } = companyData;
      // 상생업체 정보 선택 여부 -- 선택 시 true
      const connectionCompanyFlag = !utils.isEmpty(connectionCompanyNumber);
      // 등록상태 -- 등록완료 시 true
      const companyRegistrationStateFlag = utils.isEqual(companyRegistrationStateCode, '6');
      if (companyRegistrationStateFlag && !connectionCompanyFlag) {
        utils.goPage('PGE_CMY_00013', {
          companyId,
        });
      } else {
        utils.goPage('PGE_CMY_00012', {
          companyId,
        });
      }
    },
    onListClick() {
      utils.goPage('PGE_CMY_00010');
    },
    onDeleteClick() {

    },
    getSaveData() {
      const data = {
        vendorTaskSiteList: [],
        vendorCategoryList: this.vendorCategoryList,
        vendorCreditEvaluationList: this.vendorCreditEvaluationList,
      };
      utils.forEach(this.companyData, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else if (utils.isEqual(key, 'companyEstablishDTM')) {
          data[key] = utils.isDate(value) ? utils.dateformatToServer(value) : '';
        } else if (utils.isEqual(key, 'companyHompageYn')) {
          data[key] = utils.isEmpty(this.companyData.companyHomepageUrl) ? 'N' : 'Y';
        } else {
          data[key] = value;
        }
      });
      data.vendorTaskSiteList.push({
        siteId: data.siteId,
        companyRelatedTaskDivCode: data.companyRelatedTaskDivCode,
        companyTaskSiteUseYn: 'Y',
      });
      return data;
    },
    onSaveClick() {
      // date picker validation
      if (this.onClickValidate()) return false;

      const saveData = this.getSaveData();
      if (this.validation(saveData)) {
        this.saveAction(saveData);
      } else {
        utils.messageBox('warning', this.validMessage);
      }

      return null;
    },
    validation(saveData) {
      let validFlag = true;
      if (!this.connectionCompanyFlag && !this.duplicateFlag) {
        validFlag = false;
        this.validMessage = this.$t('MSG_ALT_SELT_DPCT_CHK');
        return validFlag;
      }
      utils.forEach(saveData, (value, key) => {
        if (utils.indexOf(this.validFields, key) !== -1) {
          if (utils.isEmpty(value) || utils.isEqual(value, ' ')) {
            validFlag = false;
            this.validMessage = key;
            return false;
          }
        }
        return null;
      });
      return validFlag;
    },
    saveAction(saveData) {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00026', {
          data: saveData,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            utils.goPage('PGE_CMY_00010');
          });
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onSubmitClick() {

    },
    onNationSelect(value) {
      if (utils.isEqual(value.key, 'KR')) {
        this.duplicateFlag = false;
      }
      this.companyData.nationName = value.label;
    },
    onScaleSelect(value) {
      this.companyData.companyScaleValue = value.label;
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
